import React from 'react';
import PropTypes from 'prop-types';

export const WciLayout = ({ children, type }) => {
  return (<div id={`WorldChangingIdeas__${type}`}>{children}</div>);
};

WciLayout.propTypes = {
  children: PropTypes.any
}